import { ViteReactSSG } from "vite-react-ssg";
import type { RouteRecord } from "vite-react-ssg";
import "@/styles/tokens.css";
import { Layout } from "@/components/Layout";
import { USE_CASES } from "@/content/usecases";

// React Router v7's `lazy` spreads the returned object onto the route, so a bare
// `() => import("@/pages/Home")` would spread `{ default: Cmp }` and be ignored.
// Map default → Component instead.
const page = (load: () => Promise<{ default: React.ComponentType }>) => async () => {
  const { default: Component } = await load();
  return { Component };
};

export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, lazy: page(() => import("@/pages/Home")) },
      { path: "platform", lazy: page(() => import("@/pages/Platform")) },
      { path: "system-ledger", lazy: page(() => import("@/pages/SystemLedger")) },
      { path: "use-cases", lazy: page(() => import("@/pages/UseCases")) },
      { path: "use-cases/:slug", lazy: page(() => import("@/pages/UseCaseDetail")) },
      { path: "ai", lazy: page(() => import("@/pages/Ai")) },
      { path: "enterprise", lazy: page(() => import("@/pages/Enterprise")) },
      { path: "pricing", lazy: page(() => import("@/pages/Pricing")) },
      { path: "book-demo", lazy: page(() => import("@/pages/BookDemo")) },
    ],
  },
];

export const createRoot = ViteReactSSG({ routes });

/**
 * vite-react-ssg reads `includedRoutes` from the server entry at build time to decide
 * which paths to prerender. The `:slug` param route is dropped by the default filter,
 * so expand it into one concrete path per published case study.
 */
export function includedRoutes(paths: string[]): string[] {
  return [...paths.filter((p) => !p.includes(":")), ...USE_CASES.map((u) => `/use-cases/${u.slug}`)];
}
